var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilSimpleSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_983_1367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0863 27.0002H6.5C6.23478 27.0002 5.98043 26.8948 5.79289 26.7073C5.60536 26.5197 5.5 26.2654 5.5 26.0002V20.4139C5.50012 20.149 5.60532 19.8951 5.7925 19.7077L21.2075 4.29266C21.395 4.10527 21.6493 4 21.9144 4C22.1795 4 22.4337 4.10527 22.6213 4.29266L28.2075 9.87516C28.3949 10.0627 28.5002 10.3169 28.5002 10.582C28.5002 10.8471 28.3949 11.1014 28.2075 11.2889L12.7925 26.7077C12.6051 26.8948 12.3511 27 12.0863 27.0002Z",
    stroke: "#504A4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8L24.5 15",
    stroke: "#504A4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_983_1367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSimpleSvg);
export default __webpack_public_path__ + "static/media/PencilSimpleSVG.3715e3e618820a5892bbba1373adb789.svg";
export { ForwardRef as ReactComponent };